import {
  MDBAlert,
  MDBBtn, MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getAllRoles } from "../../apiclients/streamsapi_bridge";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import { AddRole } from "../../views/popups/roles/AddRole";
import { DeleteRole } from "../../views/popups/roles/DeleteRole";
import Body from "../body/BodyPage";
import MainLinks from "../navlinks/MainLinks";
import UIConstant from "../../apiclients/UIConstant";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import TabIDConstant from "../../apiclients/TabIDConstant";
export default function RolesAndPermissions(props) {
  /************************************************************************/
  const [roles, setRoles] = useState([]);
  const [selectedRoleID, setSelectedRoleId] = useState();
  const [addRole, setAddRole] = useState(false);
  const [deleteRole, setDeleteRole] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(true);

  const dtogglePopup = () => setDeleteRole(!deleteRole);
  const addtogglePopup = () => setAddRole(!addRole);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasPrevilege, setHasPrevilege] = useState(false);
  const [position, setPosition] = useState('top-center');
  const addAdminRoleRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowdata, setRowData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
  function handleClick() {
    addAdminRoleRef.current.click();
  }

  /*************************************************************************/


  async function fetchData() {
    sessionStorage.setItem("current_link", "permissionrolessection");
    const response = await getAllRoles(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      TabIDConstant.PERM_ROLES_LINK
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    if (!rawData) {
      navigate("/");
    }


    setRoles(rawData.rolesInfo);
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
  }

  useEffect(() => {
    const disabledState = () => {
      const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
      const isAdmin = isAdminSession?.permissions ? !(isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_PERMISSION_ROLES)) : false
      setIsDisabled(isAdmin);
    }
    disabledState();
  }, []);

  useEffect(() => {
    if (hasPrevilege) {
      setTimeout(() => {
        setHasPrevilege(false)
        setErrorMessage("");
      }, 5000);
    }
  }, [hasPrevilege]);

  // function sortTheData(rolesInfo) {
  //   let finalFilterData = [...rolesInfo];
  //   finalFilterData.sort((firstObj, secObj)=> firstObj.id - secObj.id);
  //   console.log(`finalFitlerObj:::${JSON.stringify(finalFilterData)}`);
  //   return finalFilterData;
  // }

  function deleteThisRole(evntData, roleId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    setSelectedRoleId(roleId);
    setDeleteRole(true);
  }

  function showThisInf(evntData) {
    //transfering the request to specific roles information with roleID.
    navigate("/roleedit", {
      state: { roleId: evntData.id },
    });
  }

  useEffect(() => {
    let proccessdRows = [];
    roles.forEach((roleInfo) => {
      let processedRow = {
        id: roleInfo.id,
        name: roleInfo.name,
        description: roleInfo.description,
        users: roleInfo.users,
        ...(roleInfo.siteid !== 0 && {
          delete: (
            <>
              {/* <a href="#" className="ms-3"
              {...(isDisabled ? {
                title: "Do not have previlege to delete role", className: "cursor-notAllowed",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }
              } : {
                onClick: (e) => deleteThisRole(e, `${roleInfo.id}`)
              }
              )}
              defaultValue={roleInfo.id}
              target="_new"
            >  <MDBIcon fas icon="times" color="primary" /></a> */}



              <div className="d-flex align-items-center justify-content-center">
                <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                  {...(isDisabled ? {
                    className: "cursor-notAllowed custom-hover-bg p-1 deleteToolTip",
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  } : {
                    className: "custom-hover-bg p-1 cursor-pointer deleteToolTip",
                    onClick: (e) => deleteThisRole(e, `${roleInfo.id}`)
                  }
                  )}
                  defaultValue={roleInfo.id}
                >
                  <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                </div>
              </div>


            </>
          )
        })
      };
      proccessdRows.push(processedRow);
    });
    setRowData(proccessdRows)
    setFilteredRows(proccessdRows)
    setDataLoaded(true)
  }, [roles])

  const basicData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Description", field: "description" },
      { label: "Users", field: "users" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: rowdata,
  };

  // useEffect(() => {
  //   const patchTitles = () => {
  //     const tds = document.querySelectorAll('table td');
  //     tds.forEach(td => {
  //       if (!td.getAttribute('title')) {
  //         td.setAttribute('title', td.textContent.trim());
  //       }
  //     });
  //   };

  //   // Patch immediately, then again slightly later
  //   patchTitles();
  //   const timer = setTimeout(patchTitles, 100);

  //   return () => clearTimeout(timer);
  // }, [basicData]);

  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    fetchData();
  }, []);


  /********************************************************************************* */


  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(rowdata, searchValue, UIConstant.ROLES_AND_PERMISSION);

    setFilteredRows(filteredUsers);
  };


  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.rolesAndPermissionDatatable');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  return (
    <React.Fragment>
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={53}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      Roles and Permissions
                    </h5>
                  </div>

                  {isloading && (
                    <>
                      <div className="loadingclass">
                        <MDBBtn disabled>
                          <MDBSpinner
                            size="sm"
                            role="status"
                            tag="span"
                            className="me-2"
                          />
                          Loading...
                        </MDBBtn>
                      </div>
                    </>
                  )}


                  <div className="card-body px-0">
                    <div className={`actionbar ${isDisabled && 'cursor-notAllowed'}`} title={isDisabled && "Do not have previlege to add role"}>
                      <MDBBtn className="btn btn-primary green-button display-inline float-right" onClick={addtogglePopup} disabled={isDisabled}>+ {t("AddAdminRole")}</MDBBtn>
                    </div>
                    <div className='mb-2 mt-2 position-relative w-auto'>
                      <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                      <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                    </div>
                    <div className="permissionrolessectionDatatable">
                      <MDBDatatable key={searchValue} className="datatableSelect actioncolumn rolesAndPermissionDatatable"
                        fixedHeader
                        entries={50}
                        multi
                        selectable
                        searchInputProps={[]}
                        data={{
                          ...basicData,
                          rows: filteredRows, // Use filtered rows here
                        }}
                        responsive
                        hover
                        onRowClick={(event) =>
                          showThisInf(event)
                        }
                      />
                    </div>
                  </div>
                </div>
                {addRole && (
                  <PopupLoaderNew
                    // className="modal-lg"
                    title={t("AddAdminRole")}
                    content={<AddRole onClose={addtogglePopup}
                      setErrorMessage={setErrorMessage}
                      setHasPrevilege={setHasPrevilege}
                      ref={addAdminRoleRef}
                      setIsloading={setisLoading}
                    />}
                    onShow={setAddRole}
                    onClose={addtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                  />
                )}
                {deleteRole && (
                  <PopupLoaderNew
                    title={"Delete Role"}
                    content={<DeleteRole
                      roleId={selectedRoleID}
                      onClose={dtogglePopup}
                      ref={addAdminRoleRef}
                      setIsloading={setisLoading}
                    />}
                    onClose={dtogglePopup}
                    onShow={setDeleteRole}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                  />
                )}
                {hasPrevilege && (
                  <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    delay={1000000}
                    position={position} appendToBody
                  >
                    <i className="fas fa-times-circle me-3"></i>
                    <span className="alert-msg">{errorMessage}</span>
                  </MDBAlert>
                )}
              </section>
            </>
          }
        />
        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          {isDisabled ? "Do not have previlege to delete role" : "Remove"}
        </Tooltip>
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}
